"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AddCompensationCycleOwnerResponse () {
        return AddCompensationCycleOwnerResponse;
    },
    get CompensationSettingsResponse () {
        return CompensationSettingsResponse;
    },
    get DismissSalaryVisConflictBannerResponse () {
        return DismissSalaryVisConflictBannerResponse;
    },
    get GetCompanySalaryCustomFieldData () {
        return GetCompanySalaryCustomFieldData;
    },
    get GetSelectionManagersResponse () {
        return GetSelectionManagersResponse;
    },
    get GetUserHasDismissedSalaryBannerData () {
        return GetUserHasDismissedSalaryBannerData;
    },
    get GetUsersWithoutCompensationDataResponse () {
        return GetUsersWithoutCompensationDataResponse;
    },
    get RemoveCompensationCycleOwnerResponse () {
        return RemoveCompensationCycleOwnerResponse;
    },
    get UpdateCompensationCycleOwnersResponse () {
        return UpdateCompensationCycleOwnersResponse;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const CompensationSettingsResponse = _zod.z.object({
    cycleOwners: _zod.z.array(_zod.z.object({
        _id: _zod.z.string(),
        name: _zod.z.string(),
        role: _zod.z.enum([
            "Billing Admin",
            "Admin",
            "Basic Admin"
        ]),
        isAdmin: _zod.z.boolean()
    })),
    admins: _zod.z.array(_zod.z.object({
        _id: _zod.z.string(),
        name: _zod.z.string()
    })),
    billingAdmins: _zod.z.array(_zod.z.object({
        _id: _zod.z.string(),
        name: _zod.z.string()
    })),
    basicAdmins: _zod.z.array(_zod.z.object({
        _id: _zod.z.string(),
        name: _zod.z.string()
    })),
    totalSalary: _zod.z.number(),
    totalSalaryUpdatedAt: _zod.z.string().nullable(),
    integrationType: _zod.z.string().nullable()
});
const UpdateCompensationCycleOwnersResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const AddCompensationCycleOwnerResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const RemoveCompensationCycleOwnerResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const GetSelectionManagersResponse = _zod.z.object({
    managers: _zod.z.array(_zod.z.object({
        _id: _zod.z.string(),
        name: _zod.z.string(),
        jobTitle: _zod.z.string().nullable(),
        directReportCount: _zod.z.number(),
        totalCompensation: _zod.z.number(),
        managerId: _zod.z.string().nullable(),
        managerName: _zod.z.string().nullable()
    })),
    totalCount: _zod.z.number()
});
const GetUsersWithoutCompensationDataResponse = _zod.z.object({
    excludeUsersWithoutManager: _zod.z.array(_zod.z.object({
        _id: _utilsisomorphic.transformObjectId,
        name: _zod.z.string()
    })),
    excludeUsersWithoutSalary: _zod.z.array(_zod.z.object({
        _id: _utilsisomorphic.transformObjectId,
        name: _zod.z.string()
    })),
    uniqueExcludedUsers: _zod.z.array(_zod.z.object({
        _id: _zod.z.string(),
        name: _zod.z.string()
    })),
    totalCount: _zod.z.number()
});
const GetCompanySalaryCustomFieldData = _zod.z.object({
    salaryCustomField: _zod.z.object({
        visibility: _zod.z.array(_zod.z.string())
    })
});
const GetUserHasDismissedSalaryBannerData = _zod.z.object({
    userHasDismissedBanner: _zod.z.boolean().optional(),
    userHasDismissedBannerAt: _zod.z.date().optional().nullable()
});
const DismissSalaryVisConflictBannerResponse = _zod.z.object({
    success: _zod.z.boolean()
});
